<template>
  <span v-html="translate(message, this)" v-if="type == 'policy-index'"></span>
</template>
<script>
export default {
  props: {
    message: {}, //政策条款
    type: {}, // 翻译模式  网站title  website-title| 政策条款 policy-index
  },
  data() {
    return {
      website_title_replace: {
        key: ['checkout', 'information', 'shipping', 'payment', 'Your Shopping Cart', 'Thank you for your purchase!'],
        value: [
          'buyxgety.checkout',
          'shopping.information',
          'shopping.shipping',
          'shopping.payment',
          'cart.your_shopping_cart',
          'shopping.thank_you_for_your_purchase',
        ],
      },
    }
  },
  methods: {
    translate_title() {
      let title_el = document.querySelector('title')
      let title_inner_text = title_el.innerText
      return () => {
        let { key, value } = this.website_title_replace
        let new_title = title_inner_text
        key.forEach((item, index) => {
          new_title = new_title.replace(new RegExp(`${item}`, 'gi'), this.$t(`${value[index]}`) || '')
        })
        document.querySelector('title').innerText = new_title
      }
    },
  },
  created() {
    if (this.type == 'website-title') {
      this.new_translate_title = this.translate_title()
      this.new_translate_title()
    }
  },
  watch: {
    '$i18n.locale': {
      handler(newV) {
        if (this.type == 'website-title') {
          this.new_translate_title()
        }
      },
    },
  },
}
</script>
<style scoped lang='scss'></style>